/**
 * Safe error message extraction from API responses.
 * Prevents React crash (Error #31) when FastAPI returns Pydantic V2 validation errors
 * where `detail` is an array of objects {type, loc, msg, input, ctx, url} instead of a string.
 */
export const getApiError = (error, fallback = 'Something went wrong') => {
  const detail = error?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(e => e.msg || 'Validation error').join(', ');
  if (typeof detail === 'object' && detail.msg) return detail.msg;
  return fallback;
};
